{
  "长期有效": "No expiry",
  "供需审核": "Opportunity review",
  "商家自主发布": "Published by the merchant",
  "商家创建": "Created by the merchant",
  "创建人": "Created by",
  "供需审核详情": "Opportunity review details",
  "供需信息预览": "Opportunity preview",
  "运营授权代录供需信息": "Create an authorized opportunity",
  "授权运营代录": "Create on behalf of a company",
  "运营授权代录": "Entered by operations with authorization",
  "授权代录": "Authorized entry",
  "编辑供需信息": "Edit opportunity",
  "编辑并提交": "Edit and submit",
  "供需标题": "Opportunity title",
  "供需类型": "Opportunity type",
  "供应信息": "Supply offer",
  "采购需求": "Purchase request",
  "发布企业": "Publishing company",
  "所属企业": "Company",
  "按企业名称搜索": "Search by company name",
  "请选择企业": "Select a company",
  "请选择供需类型": "Select an opportunity type",
  "目标国家或地区": "Target countries or regions",
  "请选择目标国家或地区": "Select target countries or regions",
  "公开信息": "Public information",
  "公开摘要": "Public summary",
  "访客可见公开摘要": "Public summary for visitors",
  "注册企业详情预览": "Registered company preview",
  "注册用户可见": "Visible to registered users",
  "行业": "Industry",
  "采购数量": "Purchase quantity",
  "供应能力": "Supply capacity",
  "数量或供应能力": "Quantity or supply capacity",
  "有效期至": "Valid until",
  "有效截止日期": "Expiry date",
  "交付地点": "Delivery location",
  "预算或报价": "Budget or quotation",
  "详细业务要求": "Detailed requirements",
  "合作要求": "Partner requirements",
  "合作适配条件": "Partner requirements",
  "宣传图链接": "Promotional image URL",
  "订单宣传图": "Promotional image",
  "供需宣传图": "Promotional image",
  "宣传图": "Promotional image",
  "替换图片": "Replace image",
  "上传图片": "Upload image",
  "宣传图已上传": "Promotional image uploaded",
  "JPG、PNG 或 WebP，最大 2 MB": "JPG, PNG or WebP, up to 2 MB",
  "仅支持 JPG、PNG 或 WebP 图片": "Only JPG, PNG or WebP images are supported",
  "请选择不超过 2 MB 的非空图片": "Choose a non-empty image up to 2 MB",
  "请输入有效的 HTTPS 图片地址": "Enter a valid HTTPS image URL",
  "来源与披露授权": "Source and disclosure authorization",
  "资料来源": "Source",
  "代录操作人": "Entered by",
  "授权核验": "Authorization verification",
  "代录原因": "Reason for assisted entry",
  "授权凭证或记录编号": "Authorization reference",
  "授权证据索引": "Authorization evidence reference",
  "核验说明": "Verification notes",
  "已核验企业授权，同意按以上内容代录并提交审核": "I have verified the company's authorization to enter this information and submit it for review",
  "请先核验企业授权": "Verify the company's authorization first",
  "已确认发布与分级披露授权": "Publication and disclosure authorization confirmed",
  "待核验": "Awaiting verification",
  "已核实资料来源及普通商业供需性质": "I have verified the source and confirmed this is an ordinary commercial opportunity",
  "已核实发布与分级披露授权，公开摘要不含受限信息": "I have verified publication and disclosure authorization; the public summary contains no restricted information",
  "请完成核验": "Complete the verification",
  "查看审核": "Review details",
  "通过并发布": "Approve and publish",
  "退回补充": "Return for revision",
  "撤回发布": "Withdraw publication",
  "操作原因": "Reason",
  "请填写操作原因": "Enter a reason",
  "提交人工审核": "Submit for review",
  "保存草稿": "Save draft",
  "草稿": "Draft",
  "已发布": "Published",
  "未通过": "Rejected",
  "已撤回": "Withdrawn",
  "草稿已保存": "Draft saved",
  "已提交人工审核": "Submitted for review",
  "审核记录已更新": "Review recorded",
  "供需信息已更新，请关闭后重新打开再编辑": "This opportunity has changed. Close and reopen it before editing",
  "关闭编辑": "Close editor",
  "搜索标题或公开摘要": "Search titles or public summaries",
  "更新信息": "Information updated",
  "未填写标题": "No title entered",
  "未选择企业": "No company selected",
  "未填写公开摘要": "No public summary entered",
  "未填写详细描述": "No details entered",
  "供需信息查看": "View opportunities",
  "供需信息授权代录": "Create authorized opportunities",
  "供需信息审核及撤回": "Review and withdraw opportunities",
  "未认证": "Not certified",
  "会员未生效": "Membership not yet active",
  "会员已到期": "Membership expired",
  "买方认证": "Buyer certification",
  "供应方认证": "Supplier certification",
  "产品名称": "Product name",
  "产品品类": "Product category",
  "产品规格 / 型号": "Specifications / model",
  "交付日期 / 周期": "Delivery date / lead time",
  "最小起订量 MOQ": "Minimum order quantity (MOQ)",
  "目标单价及币种": "Target unit price and currency",
  "采购方式": "Purchasing method",
  "质量标准 / 认证": "Quality standards / certifications",
  "原产地要求": "Origin requirements",
  "包装要求": "Packaging requirements",
  "运输方式偏好": "Preferred shipping method",
  "付款条件": "Payment terms",
  "供应商资质要求": "Supplier qualifications",
  "请填写此项": "Please complete this field",
  "供货周期": "Supply lead time",
  "一次性": "One-off",
  "分批": "In batches",
  "长期": "Long-term",
  "海运": "Sea freight",
  "空运": "Air freight",
  "陆运": "Road freight",
  "铁路": "Rail freight",
  "多式联运": "Multimodal transport",
  "供应地点": "Supply location",
  "采购方国家 / 地区": "Buyer country / region",
  "数量 / 规模": "Quantity / scale",
  "预算 / 价格范围": "Budget / price range",
  "采购类型": "Purchase type",
  "合作类型": "Cooperation type",
  "商品采购": "Product procurement",
  "原材料采购": "Raw material procurement",
  "设备采购": "Equipment procurement",
  "服务采购": "Service procurement",
  "现货采购": "Spot purchase",
  "长期供货": "Long-term supply",
  "OEM 代工": "OEM manufacturing",
  "ODM 定制": "ODM customization",
  "采购类型和合作类型仅适用于采购需求": "Purchase type and cooperation type apply only to buying requests"
}
